export const PUNCTUATION =
    '\\.,\\+\\*\\?\\$\\@\\|#{}\\(\\)\\^\\-\\[\\]\\\\/!%\'"~=<>_:;'

export const TRIGGERS = ['@'].join('')

// Chars we expect to see in a mention (non-space, non-punctuation).
export const VALID_CHARS = `[^${TRIGGERS}${PUNCTUATION}\\s]`

// Non-standard series of chars. Each series must be preceded and followed by
// a valid char.
export const VALID_JOINS =
    `(?:` +
    `\\.[ |$]|` + // E.g. "r. " in "Mr. Smith"
    ` |` + // E.g. " " in "Josh Duck"
    `[${PUNCTUATION}]|` + // E.g. "-' in "Salier-Hellendag"
    `)`

export const QUERY_LENGTH_LIMIT = 75
export const ALIAS_LENGTH_LIMIT = 50
export const SUGGESTION_LIST_LENGTH_LIMIT = 15
export const MIN_MATCH_LENGTH = 0

export const headingTagToFontSize = {
    h1: '29px',
    h2: '24px',
    h3: '20px',
    h4: '17px',
}
